// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_kz-1";
export var quotedThread = "_kz-0";